module.exports = __webpack_public_path__ + "media/theme/OG4-01-7bb4054b.png";